import { useEffect } from 'react';
import { useAppForm } from 'shared/UI/UIKit/Form';
import type { MaxLessonsPerDay } from 'shared/api';

export const useMaxLessonsPopup = (configuration: MaxLessonsPerDay | null) => {
  const [form] = useAppForm<MaxLessonsPerDay>();

  useEffect(() => {
    if (configuration == null) {
      form.resetFields();
      return;
    }

    form.setFieldsValue(configuration);
  }, [configuration, form]);

  return {
    state: {
      form,
    },
  };
};
